<template>
    <div
        class="bg-white rounded px-7 pt-7 pb-4 mt-10 shadow-card"
    >
        <div class="inline-flex items-center">
            <a :href="route('send.index')">
                <i class="fas text-xs fa-arrow-left mr-3 cursor-pointer" />
            </a>
            <h4>Selecione a chave Pix do favorecido</h4>
        </div>

        <div class="mt-6 ml-1 relative">
            <h5 class="text-xs">Chave Pix</h5>
            <jet-input
                id="payer_name"
                type="text"
                class="mt-1 block w-full text-md"
                placeholder="Digite um CPF/CNPJ, Telefone, E-mail ou chave aleatória"
                v-model.trim="key"
                @keydown.enter.native="validateKey"
                @blur.native="errorKey = ''"
                @input="key.length === 0 ? errorKey = '' : ''"
            />
            <jet-input-error :message="errorInput" class="mt-2 absolute left-0" />
            <div class="w-full flex justify-end items-center mt-5 mb-1">
                <button
                    v-show="key.length"
                    class="bg-green-500 hover:bg-green-600 text-white text-xs leading-none p-3 rounded flex"
                    :class="loadingInfoKey ? 'cursor-not-allowed': ''"
                    :disabled="loadingInfoKey"
                    @click="validateKey"
                >
                    <div v-show="loadingInfoKey" class="text-right mr-2">
                        <i class="fas fa-spinner animate-spin" />
                    </div>
                    Prosseguir com esta chave
                </button>
            </div>
        </div>

        <div class="mt-4">
            <h5 class="text-xs mb-3">Contatos registrados</h5>
            <ul v-if="contacts.data.length" class="scrolling-auto overflow-y-auto" style="max-height: calc(100vh - 530px)">
                <li v-for="contact in contacts.data" :key="contact.id" class="flex items-center">
                    <favored class="w-full" :favored="contact" @click.native="handleClick(contact)">
                        <slot slot="action">
                            <i
                                class="text-gray-400 fas fa-times p-2 cursor-pointer hover:text-gray-600"
                                @click.stop="removeContact(contact)" />
                        </slot>
                    </favored>
                </li>
            </ul>
            <div v-else-if="contacts.loading" class="w-full text-center">
                <i class="fas fa-spinner animate-spin" />
            </div>
            <div v-else class="w-full text-center">
                <span class="text-sm">Nenhum contato registrado</span>
            </div>
        </div>
        <jet-confirmation-modal
            :scroll="false"
            :show="keyConfirm"
            @close="keyConfirm = false">
            <template #title>
                Selecionar chave PIX
            </template>
            <template #content>
                A chave informada é um CPF ou Celular?
                <div class="mt-2">
                    <jet-button
                        :class="'inline-block w-32 md:bg-gray-800 md:hover:bg-gray-800'"
                        @click.native="chosenOption('cpf')"
                    >
                    <p class="pl-9">CPF</p>  
                    </jet-button>
                    <jet-button
                        :class="'w-32 md:bg-gray-800 md:hover:bg-gray-800'"
                        @click.native="chosenOption('phone')"
                    >
                     <p class="pl-4">Celular</p>
                    </jet-button>
                </div>
            </template>
            <template #footer>
                <jet-secondary-button @click.native="keyConfirm = false">
                    Agora não
                </jet-secondary-button>
            </template>
        </jet-confirmation-modal>
        <jet-confirmation-modal
            :scroll="false"
            :show="removeConfirm"
            @close="removeConfirm = false">
            <template #title>
                Remover cadastro
            </template>
            <template #content>
                Você confirma a remoção de <span class="font-semibold">{{ customer.name }}</span> com a chave <span class="font-semibold">{{ customer.key }}?</span>
            </template>
            <template #footer>
                <jet-secondary-button @click.native="removeConfirm = false">
                    Agora não
                </jet-secondary-button>
                <jet-button
                    :class="loadingRemove ? 'md:bg-gray-300 md:hover:bg-gray-300' : ''"
                    @click.native="remove"
                >
                    <i v-show="loadingRemove" class="fas fa-spinner animate-spin mr-2" /> Remover
                </jet-button>
            </template>
        </jet-confirmation-modal>
    </div>
</template>

<script>
import JetInput from "../../../Jetstream/Input.vue";
import JetInputError from "../../../Jetstream/InputError.vue";
import JetConfirmationModal from "../../../Jetstream/ConfirmationModal.vue";
import JetButton from "../../../Jetstream/Button.vue";
import JetSecondaryButton from "../../../Jetstream/SecondaryButton.vue";
import Favored from "../components/Favored.vue";

export default {
    name: 'SelectKey',
    props: {
        contacts: { type: Object, default: () => ({}) },
        getInfoKey: { type: Function, required: true }
    },
    data(){
        return {
            key: '',
            customer: {},
            errorKey: '',
            removeConfirm: false,
            keyConfirm: false,
            loadingRemove: false,
            loadingInfoKey: false,
            dddNumbers: [11, 12, 13, 14, 15, 16, 17, 18, 19,
            21, 22, 24, 27, 28, 31, 32, 33, 34,
            35, 37, 38, 41, 42, 43, 44, 45, 46,
            47, 48, 49, 51, 53, 54, 55, 61, 62,
            64, 63, 65, 66, 67, 68, 69, 71, 73,
            74, 75, 77, 79, 81, 82, 83, 84, 85,
            86, 87, 88, 89, 91, 92, 93, 94, 95,
            96, 97, 98, 99],
            keyIsPhone: false
        }
    },
    computed: {
        errorInput(){
            return this.key.length && this.errorKey ? this.errorKey : ''
        }
    },
    methods: {
        handleClick(contact){
            this.customer = contact
            this.key = contact.key
        },
        async chosenOption(option){
            let key = '';
            let isPhone = false;

            key = this.key
            if (option == 'cpf') {
                this.keyIsPhone = false;
            }else{
                this.keyIsPhone = true;
            }
            this.keyConfirm = false;
            isPhone = this.keyIsPhone;
            this.loadingInfoKey = true
            const error = await this.getInfoKey({ ...this.customer, key, isPhone })
            if(error) this.errorKey = error
            this.loadingInfoKey = false
        },
        async validateKey(){
            this.errorKey = ''
            let key = ''

            if(this.key.includes('@')){
                key = this.key
            } else if(/^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$/gi.test(this.key)){
                key = this.key
            } else {
                const keyFormatted = this.key.replace(/[-\./()\s]+/g, '')
                if(keyFormatted.length === 11 || keyFormatted.length === 14){
                    key = this.key
                    if (this.dddNumbers.indexOf(parseInt(keyFormatted.substring(0, 2))) >= 0 && parseInt(keyFormatted.substring(2,3)) == 9) {
                        if (this.validateDocument(key)) {
                            this.keyConfirm = true;
                            return;
                        }
                    }
                } else{
                    this.errorKey = 'Chave PIX inválida'
                    return
                }
            }
             
            this.loadingInfoKey = true
            const error = await this.getInfoKey({ ...this.customer, key })
            if(error) this.errorKey = error
            this.loadingInfoKey = false
        },
        removeContact(contact){
            this.customer = contact
            this.removeConfirm = true
        },
        remove() {
            if(this.loadingRemove) return
            this.loadingRemove = true
            axios
                .delete(`/json/pix/recent-transfers?key=${this.customer.rootkey}`)
                .then((resp) => {
                    if(resp.data.error) throw new Error(resp.data.error)
                    this.$emit('refresh-contacts')
                })
                .catch((error) => {
                    this.$toast.open({
                        message: error,
                        type: 'error',
                        duration: 4000,
                        position: 'top-right'
                    })
                })
                .finally(() => {
                    this.removeConfirm = false
                    this.loadingRemove = false
                });
        },
        validateDocument(cpf) {	
            cpf = cpf.replace(/[^\d]+/g,'');	
            if(cpf == '') return false;	
            if (cpf.length != 11 || 
                cpf == "00000000000" || 
                cpf == "11111111111" || 
                cpf == "22222222222" || 
                cpf == "33333333333" || 
                cpf == "44444444444" || 
                cpf == "55555555555" || 
                cpf == "66666666666" || 
                cpf == "77777777777" || 
                cpf == "88888888888" || 
                cpf == "99999999999")
                    return false;		
            var add = 0;	
            var row = 0;
            var rev = 0;
            for (row=0; row < 9; row ++)		
                add += parseInt(cpf.charAt(row)) * (10 - row);	
                rev = 11 - (add % 11);	
                if (rev == 10 || rev == 11)		
                    rev = 0;	
                if (rev != parseInt(cpf.charAt(9)))		
                    return false;		
            add = 0;	
            for (row = 0; row < 10; row ++)		
                add += parseInt(cpf.charAt(row)) * (11 - row);	
            rev = 11 - (add % 11);	
            if (rev == 10 || rev == 11)	
                rev = 0;	
            if (rev != parseInt(cpf.charAt(10)))
                return false;		
            return true;   
        }
    },
    components: {
        JetInput,
        JetInputError,
        JetConfirmationModal,
        JetButton,
        JetSecondaryButton,
        Favored
    },
};
</script>
